exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.edar_selector[data-v-955b3c4c] {\n    max-width: 35ch;\n    min-width: 35ch;\n    padding: 1ch;\n}\n", ""]);

// exports
